/**
 * @constructor
 * @implements {Foundation.View.Interface.ErrorList}
 * @extends {Foundation.Promise}
 * @param {jQuerySelector} viewContainer
 */
Foundation.View.Mobile.ErrorList = function (viewContainer) {
    Foundation.Promise.call(this);
    
    /** @type {jQuery} */
    this.view = jQuery(viewContainer);
    if (this.view[0]) {
        //this.view.find("ul").listview();
        this.fulfill();
    }
    else {
        this.fail();
    }
    
    this.clear();
};
Foundation.inherit(Foundation.View.Mobile.ErrorList, Foundation.Promise);

Foundation.View.Mobile.ErrorList.prototype.clear = function () {
    this.view.hide().find("ul li").remove();
};

/**
 * @param {Foundation.Observable} obj
 */
Foundation.View.Mobile.ErrorList.prototype.setErrorsFromObservable = function (obj) {
    this.clear();
    
    var errorArray = obj.get("errors") || [];
    if (errorArray.length) {
        var list = this.view.find("ul");
        var heading = errorArray.length === 1 ? "Error Found" : "Errors Found";
        list.append(jQuery("<li>").html(heading));
        for (var i = 0; i < errorArray.length; i++) {
            var message = Foundation.isString(errorArray[i])
                              ? errorArray[i] 
                              : errorArray[i]["message"];
            var listItem = jQuery("<li>").addClass('ui icon alert').html(message);
            list.append(listItem);
        }
        //list.listview("refresh");
        this.view.fadeIn(300);
        //jQuery.mobile.silentScroll(this.view.offset()["top"] - 10);
    }
};

Foundation.View.ErrorList = Foundation.View.Mobile.ErrorList;


